import { Link } from 'react-router-dom';

export default function Footer({ links }) {
  return (
    <footer className="footer">
      <div className="footer-brand">
        <img src="/assets/logo.png" alt="" />
        <strong>KozelSMP</strong>
      </div>
      <div className="footer-links">
        <Link to="/legal/offer">Договор-оферта</Link>
        <Link to="/legal/privacy">Политика обработки персональных данных</Link>
        <Link to="/legal/payment-security">Порядок проведения оплаты и безопасность операций</Link>
      </div>
      <div className="footer-contact">
        <span>Почта для связи:</span>
        <a href={`mailto:${links.email}`}>{links.email}</a>
      </div>
    </footer>
  );
}
